<div
  *ngIf="formData"
  class="mu-radio-credit-card"
  [ngClass]="{
    'mu-radio-credit-card-select': skin,
    'mu-radio-credit-card-active': formData?.get(controlName)?.value === creditCard.cardId
  }"
>
  <div class="mu-radio-credit-card-control mu-radio-credit-card-{{ creditCard?.franchise }}" [formGroup]="formData">
    <i
      class="mu-radio-credit-card-icon-extra {{ creditCard?.icon }} {{ creditCard?.iconColor }}"
      aria-hidden="true"
      *ngIf="creditCard?.icon"
    ></i>
    <img
      class="mu-radio-credit-card-icon mu-radio-credit-card-icon-{{ creditCard.franchise.toLocaleLowerCase() }}"
      src="assets/images/icons/express-basic/icon-{{ creditCard.franchise.toLowerCase() }}.svg"
      alt=""
    />
    <p-radioButton
      class="mu-radio-button"
      value="{{ creditCard.cardId }}"
      [disabled]="creditCard?.disabled || creditCard?.inputHidden || creditCard?.icon"
      [name]="controlName"
      [formControlName]="controlName"
      [label]="label"
      [ngClass]="{ 'mu-radio-credit-card-input-hidden': creditCard?.inputHidden || creditCard?.icon }"
      (click)="actionEvent()"
    ></p-radioButton>
    <span *ngIf="creditCard?.extraColor" class="mu-radio-credit-card-text-extra {{ creditCard?.extraColor }}">{{
      creditCard?.extraText
    }}</span>
  </div>
  <ng-container *ngIf="skin; else bloqueCrediCard">
    <div class="mu-radio-credit-card-number" *ngIf="creditCard.last4digits">**** {{ creditCard.last4digits }}</div>
  </ng-container>
  <ng-template #bloqueCrediCard>
    <div class="mu-radio-credit-card-number" *ngIf="creditCard.last4digits">**** **** **** {{ creditCard.last4digits }}</div>
  </ng-template>
  <app-mu-button-extra
    *ngIf="creditCard.showButton || creditCard.button"
    class="mu-radio-credit-card-button"
    [colSize]="5"
    [colMdSize]="4"
    [colLgSize]="4"
    [label]="creditCard.button.label"
    [icon]="'fa-plus-circle'"
    [hasPermission]="creditCard.button.hasPermission"
    [action]="creditCard.button.action"
    [actionList]="actionList"
    [redirect]="creditCard.button.redirect"
  ></app-mu-button-extra>
</div>
